const getPrivacyPolicyUrl = locale =>
  locale === 'de'
    ? 'https://www.workpath.com/de/datenschutzerklarung#okr-tool'
    : 'https://www.workpath.com/en/privacy-policy#okr-tool';

export { getPrivacyPolicyUrl };
